import { render, staticRenderFns } from "./AppContentTabItem.vue?vue&type=template&id=10f6932a&"
import script from "./AppContentTabItem.vue?vue&type=script&lang=js&"
export * from "./AppContentTabItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports